import FilesDropzoneLoader from './FilesDropzoneLoader'
import CurrentFilesList from './CurrentFilesList'

export default FilesDropzoneLoader
export { CurrentFilesList }
